import React from 'react';

export const getTooltipForNextButton = validationErrors => {
  if (!validationErrors || !validationErrors?.length) {
    return undefined;
  }
  return validationErrors?.map(v => v.errors.map(e => `${v.propertyName}: ${e}`)).flat()?.concat(validationErrors?.filter(v => v.missing)?.map(v => `${v.propertyName} is missing`)).map(s => <div>{s}</div>);
}